export default ({...props}) => {
  const {space} = props.theme
  return `
    & > * {
      padding: ${space(1)}px;
      align-items: center;
      margin: 0px;
      & > * {
        margin: 0px;
      }

      &.flex,
      &.MuiTypography-root{
        display: flex;
      }
    }
    &[ap_type="row"]{
      flex-direction: row;
      flex-wrap: wrap;
      & > *:last-child{
        padding-right: 0px;
        margin-right: 0px;
      }
      & > div {
        display: flex;
      }
    }
    &[ap_type="column"]{
      flex-direction: column;
      flex-wrap: wrap;
    }
  `
}
